import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-admin/shared/api/axios";
import { SelectionDropdown } from "@libs/zapi-ui/custom";
import { TAdminProjectResponse } from "../model/schema";

type TChapterSelectProps = {
  chapterId: string;
  setChapterId: (chapter: string) => void;
  projectId?: string;
};

export function ChapterSelect({ setChapterId, chapterId, projectId }: TChapterSelectProps) {
  const { data } = useQuery<{ id: string; label: string; value: string }[]>({
    queryKey: ["get-project", projectId],
    queryFn: async () => {
      const response = await $api.get<{
        data: TAdminProjectResponse;
      }>(`/admin/projects/${projectId}`);
      return (
        response?.data?.data?.projectChapters
          ?.map((i) => ({
            id: `${i.id}`,
            value: i.projectTemplateChapterSlug || "",
            label: `ID: ${i.id} - Name: ${i.projectTemplateChapterSlug}`
          }))
          ?.sort((a, b) => a.label.localeCompare(b.label)) || []
      );
    },
    enabled: !!projectId
  });

  return (
    <div className="space-y-2 w-[258px]">
      <SelectionDropdown
        placeholder="Select Chapter"
        options={[{ label: "All Chapters", value: "" }, ...(data || [])]}
        value={data?.find((i) => i.id === chapterId)?.value}
        onChange={(v) => {
          setChapterId(data?.find((i) => i.value === v)?.id || "");
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
